import { TokenModel } from "@/api-connector/play-digital-api/models/login-models";
import { cookieStore } from "@/shared/utils/store/use-store";
import { computed, readonly, ref } from "vue";

/* ************************************* USER TOKEN ************************* */

// dont change the name, because BE check the cookie value
const tokenCookieName = "igt-oauth-token";
const authTokenModel = ref(cookieStore.get<TokenModel>(tokenCookieName));
const cookieDurability = computed(() => parseInt(authTokenModel.value?.tokenParams.expiresIn ?? "3600") / 3600 / 24);

export const authToken = computed(() => authTokenModel.value?.token);

export const storeUserToken = (tokenModel: TokenModel): void => {
    authTokenModel.value = tokenModel;
    cookieStore.set(tokenCookieName, tokenModel, { expires: cookieDurability.value });
};

/* ******************************* BONUS MODAL ******************************* */
const obtainableBonusCookieName = "obtainable-bonus-closed";
const isObtainableBonusOpenInternal = ref(!cookieStore.get<boolean>(obtainableBonusCookieName));
export const isObtainableBonusOpen = readonly(isObtainableBonusOpenInternal);

export const storeObtainableBonusClosed = (): void => {
    isObtainableBonusOpenInternal.value = false;
    cookieStore.set(obtainableBonusCookieName, true);
};

/* ******************************** SHARED ******************************** */
export const removeUserCookies = (): void => {
    authTokenModel.value = null;
    cookieStore.remove(tokenCookieName);

    isObtainableBonusOpenInternal.value = false;
    cookieStore.remove(obtainableBonusCookieName);
};
